import { useState } from 'react';
import { KPODataFetchWrapper } from '../wrappers/KPODataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { EupType } from "../../model";

interface KpoCardMetadata {
    kpoId: string;
    cardNumber: string;
    cardStatus?: string;
}

export const useKpoPrint = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);
    const [lastGenerationSuccess, setLastGenerationSuccess] = useState(false);
    const [lastGeneratedCardNumber, setLastGeneratedCardNumber] = useState<string | null>(null);
    const [lastCardMetadata, setLastCardMetadata] = useState<KpoCardMetadata | null>(null);

    const fetchKpoPrintData = (
        eupType: EupType,
        kpoCardNumbers: string,
        sheetName: string,
    ) => {
        // Resetuj stan sukcesu przed nowym generowaniem
        setLastGenerationSuccess(false);
        setLastGeneratedCardNumber(kpoCardNumbers);
        setLastCardMetadata(null);
        
        const dataFetch = KPODataFetchWrapper.wrapKpoCardPrintDataFetch(
            eupType,
            kpoCardNumbers,
            sheetName,
        );
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    }
    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
        // Resetuj również stan sukcesu - ważne przy błędzie generowania
        setLastGenerationSuccess(false);
    };

    const handleProgressComplete = (wasSuccess: boolean, metadata?: KpoCardMetadata) => {
        console.log('🎯 useKpoPrint: handleProgressComplete called with:', { wasSuccess, metadata });
        resetProgress();
        // Oznacz generowanie jako zakończone sukcesem tylko gdy faktycznie był sukces
        if (wasSuccess) {
            setLastGenerationSuccess(true);
            if (metadata) {
                console.log('✅ useKpoPrint: Setting lastCardMetadata:', metadata);
                setLastCardMetadata(metadata);
            } else {
                console.warn('⚠️ useKpoPrint: No metadata received in handleProgressComplete');
            }
            // Wywołaj callback przekazany z komponentu rodzica tylko przy sukcesie
            if (onComplete) {
                onComplete();
            }
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchKpoPrintData,
        resetProgress,
        handleProgressComplete,
        lastGenerationSuccess,
        lastGeneratedCardNumber,
        lastCardMetadata,
        backTo: '/' // Nie jest już używany, ale zachowany dla kompatybilności
    };
};